<template>
    <div>
        <div class="menu_top padding_bottom_64">
            <div class="cart_suggesttitle margin_top_32 display_flex  justify-content_flex-justify"><span>{{$t('order.orderxinxi')}}</span></div>
            <div class="cartbox display_flex  justify-content_flex-justify">
                <span class="padding_left_32">{{$t('order.orderinfo')}}</span>
                <span class="padding_right_96">{{$t('order.danjia')}}</span>
            </div>
            <div>
                <div v-for="item in orderlist" class="margin_top_24">
                    <div class="cartlist">
                        <div class=" display_flex  justify-content_flex-justify align-items_center">
                            <div class="person_cartlist_Item_R">
                                <div class="display_flex  align-items_center">
                                    <div class="roundType">{{rank_type[item.prdType]}}</div>
                                    <div class="carttitle">
                                        <div class="title">{{item.title}}</div>
                                       
                                    </div>
                                    <div class="price">¥ {{item.discountPrice}}</div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="cartbox margin_top_32 display_flex  justify-content_flex-justify paymoneybox">
                <span>{{$t('order.productNum')}}：{{orderlist.length}}</span>
                <div>{{$t('personal.maypay')}}：<span class="totalpay">¥ {{totalprice}}</span></div>
            </div>
            <div v-if="true">
                <div class="cart_suggesttitle margin_top_88 "><span>{{$t('order.payway')}}</span></div>
                <div class="display_flex  justify-content_flex-justify align-items_center">
                    <div>
                        <div v-if="false" class="payWay alipay" :class="{'active':(currentway=='Alipay')}" @click="pay('Alipay')"></div>
                        <div class="payWay WeChat" :class="{'active':(currentway=='WeChat')}" @click="pay('WeChat')"></div>
                    </div>
                    <div class="pay_btn" :class="{'active':(currentway=='Alipay' || currentway=='WeChat')}" @click="commit()">{{$t('order.commit')}}</div>
                </div>
            </div>   
            
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}


// 购物车
.cart_suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding: 32px 0;
    box-sizing: border-box;

    .lookall {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #262633;
    }
}

.padding_left_394 {
    padding-left: 394px;
    box-sizing: border-box;
}

.padding_left_430 {
    padding-left: 430px;
    box-sizing: border-box;
}

.padding_left_72 {
    padding-left: 72px;
    box-sizing: border-box;
}

.padding_left_24 {
    padding-left: 24px;
    box-sizing: border-box;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.padding_left_70 {
    padding-left: 70px;
    box-sizing: border-box;
}

.padding_left_32 {
    padding-left: 32px;
    box-sizing: border-box;
}

.margin_top_32 {
    margin-top: 32px;
}

.margin_top_24 {
    margin-top: 24px;
}

.margin_top_88{
    margin-top: 88px;
}

.padding_top_32 {
    padding-top: 32px;
    box-sizing: border-box;
}

.padding_left_280 {
    padding-left: 280px;
    box-sizing: border-box;
}

.padding_left_162 {
    padding-left: 162px;
    box-sizing: border-box;
}

.padding_left_366 {
    padding-left: 366px;
    box-sizing: border-box;
}

.padding_right_96{
    padding-right: 96px;
    box-sizing: border-box;
}

.margin_top_40 {
    margin-top: 40px;
    box-sizing: border-box;
}

.margin_bottom_32{
    margin-bottom:32px;
}

.padding_right_16 {
    padding-right: 16px;
    box-sizing: border-box;
}
.padding_right_28{
    padding-right:28px;
    box-sizing: border-box;
}
.icon_round {
    width: 24px;
    height: 24px;
    border: 1px solid #D5D5D7;
    border-radius: 50%;
}

.cartbox {
    height: 64px;
    line-height: 64px;
    background: #F8FBFD;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    text-align: left;
    &.payway{
        padding:0 46px 0 28px;
        box-sizing: border-box;
        .maincolor{
            color:#FF7467;
        }
    }
    &.paymoneybox{
        padding:0 96px 0 32px;
        box-sizing: border-box;
        .totalpay{
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF7467;
            padding-left: 30px;
        }
    }
    .totalprice {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF7467;
        margin-left: 30px;
    }

    .paybtn {
        width: 180px;
        height: 100%;
        line-height: 64px;
        background: #60DEB4;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        display: inline-block;
        margin-left: 40px;
        vertical-align: top;
    }
}

.cartlist {

    .cartlist_Item {
        margin-top: 24px;

    }

    .person_cartlist_Item_R {
        width: 100%;
        background: #FFFFFF;
        border: 1px solid #F4F4F5;
        padding: 24px 0 24px 24px;
        box-sizing: border-box;
        .person_order_Each{
            padding-bottom: 24px;
            box-sizing: border-box;
        }

        .roundType {
            width: 72px;
            height: 72px;
            line-height: 72px;
            color: #fff;
            border-radius: 50%;
            background-color: #60DEB4;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
        }

        .carttitle {
            width: 650px;
            margin-right:  80px;
            margin-left: 24px;
            text-align: left;

            .title {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #262633;
                line-height: 36px;
                @include linelimt(1);
            }

            .desc {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #888888;
                line-height: 24px;
                @include linelimt(1);
                margin-top: 4px;
            }
        }

        .price {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF7467;
            padding-left: 186px;
            box-sizing: border-box;
        }

        .delbtn {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
        }
    }
}

// 个人中心
.person_info {
    width: 100%;
    height: 240px;
    position: relative;
    background: #F8FBFD;
    padding: 64px 0 0 64px;
    box-sizing: border-box;

    .headImg {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 2px solid #fff;
        margin-right: 60px;
        background: #678;

    }

    .edit_btn {
        width: 144px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 18px;
        border: 1px solid #60DEB4;
        position: absolute;
        right: 32px;
        top: 32px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #60DEB4;
        cursor: pointer;

    }

    .info_detail {
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;

        .nickname {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #51515C;
            line-height: 28px;
            padding-bottom: 10px;
            box-sizing: border-box;
        }

        .info_left {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A8A8AD;
            line-height: 28px;
            padding-right: 16px;
            box-sizing: border-box;
        }

        .info_right {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            line-height: 28px;
        }
    }
}

.person_order_box {
    height: 40px;
    line-height: 40px;
    background: #F8FBFD;
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
}

.cusor{
    cursor: pointer;
    &:nth-of-type(2){
        margin-left: 40px;
    }
}

.payWay{
    width: 316px;
    height: 120px;
    background-size: 174px 86px;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid #E9E9EB;
    display: inline-block;
    cursor: pointer;
    &.alipay{
        background-image: url('http://p1.fishqc.net/FqRbgYcpixtzyJq5AFcQ5bPvJRtA');
    }
    &.WeChat{
        background-size: 233px 78px;
        background-image: url('http://p1.fishqc.net/FmOSU1EyZ9UWSDtRD_yBA3SY-8Wa');
    }

    &:nth-of-type(1){
        margin-right: 64px;
    }
    &:hover{
        border: 1px solid #60DEB4;
    }
    &.active{
        border: 1px solid #60DEB4;
    }

}

.pay_btn{
    width: 180px;
    height: 64px;
    line-height:64px;
    background-color: #E9E9EB;
    cursor: pointer;
    font-size: 18px;
    font-family: 'PingFang SC';
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    &.active{
        background-color: #60DEB4;
    }
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import {myMixin} from '@/mixin/mixin.js'
import { submitOrderAndPayApi,CartlistApi,orderPayApi} from '@/api/api.js'
export default {
    name: '',
    components: {
        banner,
    },
    mixins:[myMixin],
    data() {
        return {
            orderlist:[],
            totalamount:0,  //总额
            currentway:'WeChat',
            sesstiondata:{}
        }
    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        },
        totalprice(){  //计算总额
            this.totalamount =  0;
            this.orderlist.forEach((val)=>{
                if(val.discountPrice!=null && val.discountPrice!=''){  //购物车或弹窗入口
                    this.totalamount  = this.totalamount + Number(val.discountPrice)
                }else if(val.price !=null && val.price!=''){   //个人中心我的订单或者订单详情入口
                    this.totalamount  = this.totalamount + Number(val.price)
                }
                
            })
            return this.totalamount
        },
    },
    mounted() {
        this.orderlist = JSON.parse(window.sessionStorage.getItem('orderlist'));

        // if(this.$route.query.paytype == '2'){
        //    this.sesstiondata = JSON.parse(window.sessionStorage.getItem('orderlist'));
        //    this.orderlist = this.sesstiondata.prdList
            
        // }else{
            
        // }
        
        console.log(this.orderlist)
    },
    methods: {
        tapchoose(item) {
            this.currenttap = item
        },
        pay(type){
            this.currentway = type
            // this.$router.push({
            //     path:'/payway?type='+type
            // })
        },
        commit(){
            if(this.$route.query.paytype == 2){
                var orderdetail = JSON.parse(window.sessionStorage.getItem('orderlist')) 
                orderPayApi({
                    orderNo: this.$route.query.orderNo,
                    payType:2
                }).then(res => {
                    if (res.code == 200) {
                        this.getCartNum()
                        window.sessionStorage.setItem('buystatus',JSON.stringify(res.data));
                        this.$router.push({
                            path:'/payway',
                            query:{
                                type:this.currentway,
                                orderNo:res.data.orderNo,

                            }
                        })
                    } else {
                        this.toast(res.message)
                    }
                })
            }else{
                var prdListString = []

                this.orderlist.forEach((val)=>{
                    prdListString.push({
                        prdId:val.prdId,
                        prdType:val.prdType
                    })
                })

                submitOrderAndPayApi({
                    prdParam:JSON.stringify(prdListString),
                    payType:2
                }).then(res => {
                    if (res.code == 200) {
                        window.sessionStorage.setItem('buystatus',JSON.stringify(res.data));
                        this.$router.push({
                            path:'/payway',
                            query:{
                                type:this.currentway,
                                orderNo:res.data.orderNo,

                            }
                        })
                    } else {
                        this.toast(res.message)
                    }
                })
            }
            
        },
        getCartNum(){
            CartlistApi({}).then(res => {
                if (res.code == 200) {
                    // this.shoppingNUM = res.data.length
                    this.$store.commit('getcartsnum',res.data.length)
                    // console.log(this.shoppingNUM)
                } else if(res.code == 204) {
                    

                }else{
                    // this.toast(res.message)
                }
            })
        }
    }
}
</script>